<template>
  <div class="shop-detail-wrapper">
    <div class="shop-top">
      <div class="inner">
        <div class="shop-msg">
          <img class="shop-logo" :src="shopImg" />
          <span class="shop-name">{{ $route.query.shopName }}</span>
        </div>
        <div class="share-block">
          <div class="inner" @click="starClick">
            <span class="iconfont" :class="{
              'icon-a-lujing1': state.isStar,
              'icon-lujing1': !state.isStar
            }"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="product-list">
      <ProductList />
    </div>
  </div>
</template>

<script setup>
import { computed, reactive } from 'vue';
import ProductList from './components/ProductList.vue';
// import ShopDetail from './components/ShopDetail.vue';
import {
  collectShopAdd,
  collectShopExists,
  collectShopRemove
} from '@/apis/goods';
import { throttle } from '@/utils/util';
import { ElMessage } from 'element-plus';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const { t } = useI18n();
const $route = useRoute();
const state = reactive({
  isStar: false
});
const starClick = throttle(async () => {
  if (!state.isStar) {
    let params = {
      storeId: $route.query.sellerId,
      storeName: $route.query.shopName,
      storeSource: $route.query.source,
      storeUrl: window.location.href,
      deviceType: 'pc'
    };
    await collectShopAdd(params);
    ElMessage.success(t('common.collectSuccess'));
    state.isStar = true;
  } else {
    await collectShopRemove($route.query.sellerId);
    state.isStar = false;
    ElMessage.success(t('common.cancelCollectSuccess'));
  }
}, 1000);
const collectExistsFun = async () => {
  const res = await collectShopExists({
    storeId: $route.query.sellerId
  });

  state.isStar = res;
};
collectExistsFun();
const shopImg = computed(() => {
  let img = '';
  switch ($route.query.source) {
    case 'AL':
      img = require('@/assets/images/common/1688.png');
      break;
    case 'WD':
      img = require('@/assets/images/common/weidian.png');
      break;
    case 'TB':
      img = require('@/assets/images/common/taobao.png');
      break;
    case 'GF':
      img = require('@/assets/images/common/xianyu.png');
      break;
    default:
      img = require('@/assets/images/common/default-shop-img.png');
      break;
  }
  return img;
});
</script>

<style lang="scss" scoped>
.shop-detail-wrapper {
  width: 100%;
  background-color: var(--white-color-1);

  .shop-top {
    height: 148px;
    width: 100%;
    background: var(--background-f2f4f8);
    margin-bottom: 40px;
    display: flex;
    align-items: center;

    .inner {
      width: 1320px;
      margin: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .shop-msg {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .shop-logo {
          width: 80px;
          height: 80px;
          margin-right: 10px;
          display: block;
        }

        .shop-name {
          color: var(--black-color-3d);
          font-size: 16px;
          font-weight: bold;
        }
      }

      .share-block {
        color: var(--black-color-9);

        .inner {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 54px;
          height: 54px;
          background-color: var(--white-color-1);
          border-radius: 50%;
          cursor: pointer;

          .iconfont {
            font-size: 20px;
            cursor: pointer;
          }

          .icon-lujing1 {
            color: var(--black-color-9);
          }

          .icon-a-lujing1 {
            color: #ff8f1f;
          }
        }
      }
    }
  }

  .product-list {
    width: 1320px;
    margin: 0 auto;
  }
}
</style>
